function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "13",
  height: "12",
  viewBox: "0 0 13 12",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M10.408 1.176c1.331-.486 1.904.158 1.285 1.426l-3.81 7.8c-.623 1.274-1.456 1.204-1.908-.128 0 0-.3-1.514-1.31-2.636-1.01-1.121-2.484-1.577-2.484-1.577C.889 5.49.926 4.633 2.252 4.15l8.156-2.974z",
  stroke: "#222",
  strokeWidth: ".8",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round"
})));